"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiFlip = function IconUiFlip(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M39.141 15.418A38.888 38.888 0 0 0 24 12.758a38.671 38.671 0 0 0-15.067 2.656c-4.491 1.84-6.767 4.2-6.767 7.009 0 2.892 2.276 5.292 6.755 7.128A38.7 38.7 0 0 0 24 32.212h.711l-4.259 4.235 1.41 1.418 6.682-6.644-6.663-6.8-1.429 1.4 4.3 4.4H24a36.739 36.739 0 0 1-14.31-2.516c-3.666-1.5-5.524-3.28-5.524-5.282 0-1.92 1.858-3.656 5.536-5.164a36.749 36.749 0 0 1 14.3-2.5 36.927 36.927 0 0 1 14.367 2.505c3.628 1.5 5.467 3.238 5.467 5.16s-1.8 3.663-5.351 5.164l-.921.389.78 1.842.921-.389c4.36-1.844 6.571-4.2 6.571-7.006s-2.257-5.168-6.695-7.006z"
  }));
};

IconUiFlip.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiFlip;
exports.default = _default;